export default __webpack_public_path__ + "static/media/storage.e6ea5631.svg";